import { supabase } from './supabase.js';

export async function setCheckoutBuyerDelivery(stripeSessionId, buyerDeliveryMode, shippingAddress = null) {
  const sid = String(stripeSessionId ?? '').trim();
  if (!sid) return { error: 'missing_session' };
  const { error } = await supabase.rpc('set_marketplace_checkout_buyer_delivery', {
    p_stripe_session_id: sid,
    p_buyer_delivery_mode: buyerDeliveryMode,
    p_shipping_address: shippingAddress,
  });
  if (error) {
    console.error('[transactionLogisticsService] setCheckoutBuyerDelivery', error.message);
    return { error: error.message };
  }
  return { error: null };
}

export async function sellerSetTransactionDropoff(transactionId, { tracking, status } = {}) {
  const id = String(transactionId ?? '').trim();
  if (!id) return { error: 'missing_transaction' };
  const { error } = await supabase.rpc('seller_set_transaction_dropoff', {
    p_transaction_id: id,
    p_tracking: tracking ?? null,
    p_status: status ?? null,
  });
  if (error) {
    console.error('[transactionLogisticsService] sellerSetTransactionDropoff', error.message);
    return { error: error.message };
  }
  return { error: null };
}

export async function partnerSetTransactionOutbound(transactionId, tracking) {
  const id = String(transactionId ?? '').trim();
  const tr = String(tracking ?? '').trim();
  if (!id || !tr) return { error: 'missing_fields' };
  const { error } = await supabase.rpc('partner_set_transaction_outbound', {
    p_transaction_id: id,
    p_tracking: tr,
  });
  if (error) {
    console.error('[transactionLogisticsService] partnerSetTransactionOutbound', error.message);
    return { error: error.message };
  }
  return { error: null };
}
